import { render, staticRenderFns } from "./MonthPersonView.vue?vue&type=template&id=0467c053&scoped=true&"
import script from "./MonthPersonView.vue?vue&type=script&lang=js&"
export * from "./MonthPersonView.vue?vue&type=script&lang=js&"
import style0 from "./MonthPersonView.vue?vue&type=style&index=0&id=0467c053&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0467c053",
  null
  
)

export default component.exports